import React from 'react';
import { InsightData } from '../../../../MoleculeSearch.type';
import './InsightCard.styles.scss';

export interface InsightCardProps extends InsightData {}

const InsightCard: React.FC<InsightCardProps> = ({
  title,
  value,
  description,
  icon,
  iconColor,
  cotData,
}) => {
  return (
    <div className="insight-card">
      <div className="insight-title">
        <i className={icon} style={{ color: iconColor }}></i>
        {title}
      </div>
      {cotData && cotData.length > 0 ? (
        <div className="insight-cot-container">
          {cotData.map((cot, index) => (
            <div key={index} className="insight-cot-item">
              <span className="insight-cot-label">{cot.label}</span>
              <span className="insight-cot-value">{cot.value}</span>
            </div>
          ))}
        </div>
      ) : (
        <div className="insight-value">{value}</div>
      )}
      <div className="insight-desc">{description}</div>
    </div>
  );
};

export default InsightCard;
